import React from 'react';
import '../../admin-stats.css';

function StatsCards({ overviewData, loading }) {
  if (loading || !overviewData) {
    return (
      <div className="stats-cards-container">
        <div className="loading">Loading statistics...</div>
      </div>
    );
  }

  const stats = overviewData;

  return (
    <div className="stats-cards-container">
      <div className="stats-card">
        <div className="card-header">
          <h3>Total Users</h3>
        </div>
        <div className="card-value">{stats.users?.total || 0}</div>
        <div className="card-detail">
          {stats.users?.newThisPeriod > 0 && (
            <span className="positive">+{stats.users.newThisPeriod} new</span>
          )}
        </div>
      </div>

      <div className="stats-card">
        <div className="card-header">
          <h3>Total Content</h3>
        </div>
        <div className="card-value">{stats.content?.total || 0}</div>
        <div className="card-detail">
          <span>{stats.content?.published || 0} published</span>
          <span className="warning">{stats.content?.hidden || 0} hidden</span>
        </div>
      </div>

      <div className="stats-card">
        <div className="card-header">
          <h3>Total Activity</h3>
        </div>
        <div className="card-value">{stats.activity?.total || 0}</div>
        <div className="card-detail">
          <span>{stats.activity?.totalComments || 0} comments</span>
        </div>
      </div>

      <div className="stats-card">
        <div className="card-header">
          <h3>Pageviews</h3>
        </div>
        <div className="card-value">{stats.engagement?.totalPageviews || 0}</div>
        <div className="card-detail">
          <span>Avg: {stats.engagement?.avgViewsPerContent || 0} per content</span>
        </div>
      </div>

      <div className="stats-card">
        <div className="card-header">
          <h3>Active Users</h3>
        </div>
        <div className="card-value">{stats.users?.activeThisPeriod || 0}</div>
        <div className="card-detail">
          <span>Last 30 days</span>
        </div>
      </div>

      <div className="stats-card">
        <div className="card-header">
          <h3>System Health</h3>
        </div>
        <div className="card-value">
          <span className="status-indicator healthy">✓</span>
        </div>
        <div className="card-detail">
          <span>{stats.health?.databaseStatus || 'healthy'}</span>
        </div>
      </div>
    </div>
  );
}

export default StatsCards;
